<script setup lang="ts">
import { computed } from 'vue';

export type AvatarSize = 'sm' | 'md' | 'lg';

export interface AvatarProps {
	src?: string;
	alt?: string;
	initials?: string;
	size?: AvatarSize;
}

const props = withDefaults(defineProps<AvatarProps>(), {
	alt: '',
	size: 'md',
});

const sizeClasses: Record<AvatarSize, string> = {
	sm: 'h-8 w-8 text-label',
	md: 'h-10 w-10 text-body',
	lg: 'h-14 w-14 text-title',
};

const fallback = computed(() => {
	if (props.initials) return props.initials.slice(0, 2).toUpperCase();
	if (props.alt) return props.alt.slice(0, 2).toUpperCase();
	return '?';
});
</script>

<template>
	<div
		:class="[
			'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-300 font-semibold text-white',
			sizeClasses[size],
		]"
	>
		<img v-if="src" :src="src" :alt="alt" class="h-full w-full object-cover" />
		<span v-else>{{ fallback }}</span>
	</div>
</template>
